import React from 'react';

interface CardProps {
  children?: React.ReactNode;
  className?: string;
  padding?: string;
  hoverable?: boolean;
}

export const Card = ({
  children,
  className = '',
  padding = 'p-6',
  hoverable = false,
}: CardProps) => {
  return (
    <div
      className={`bg-white dark:bg-gray-800 rounded-lg shadow transition-colors ${padding} ${
        hoverable ? 'hover:shadow-lg cursor-pointer' : ''
      } ${className}`}
    >
      {children}
    </div>
  );
};

interface CardHeaderProps {
  children?: React.ReactNode;
  className?: string;
}

export const CardHeader = ({ children, className = '' }: CardHeaderProps) => {
  return (
    <div className={`border-b border-gray-200 dark:border-gray-700 pb-4 mb-4 ${className}`}>
      {children}
    </div>
  );
};

interface CardTitleProps {
  children?: React.ReactNode;
  className?: string;
}

export const CardTitle = ({ children, className = '' }: CardTitleProps) => {
  return (
    <h3 className={`text-lg font-semibold text-gray-900 dark:text-white transition-colors ${className}`}>
      {children}
    </h3>
  );
};

interface CardContentProps {
  children?: React.ReactNode;
  className?: string;
}

export const CardContent = ({ children, className = '' }: CardContentProps) => {
  return (
    <div className={className}>
      {children}
    </div>
  );
};

export default Card;
